import cn from "classnames";
import { useEffect, useRef } from "react";
import { Control } from "./control";
import { ControlBoxProps } from "./types";
import styles from "./styles.module.scss";

export const ControlBox = ({
  dataTestId,
  isSingleViewMode,
  isHiddenControl,
  position,
  isCenterMode,
  offsetLeft,
  onClick,
}: ControlBoxProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!buttonRef.current) {
      return;
    }

    if (!isCenterMode) {
      buttonRef.current.style.removeProperty("left");
    } else {
      buttonRef.current.style.setProperty("left", `${offsetLeft}px`);
    }
  }, [isCenterMode, offsetLeft]);

  const controlBoxDataTestId = `${dataTestId}-${position}`;

  return (
    <div
      className={cn(styles["control-box"], styles[`${position}-control-box`], {
        [styles.transparent]:
          isSingleViewMode || isHiddenControl || isCenterMode,
      })}
      data-test-id={`${controlBoxDataTestId}-control-box`}
    >
      <Control
        isSingleViewMode={isSingleViewMode}
        isCenterMode={isCenterMode}
        isHiddenControl={isHiddenControl}
        dataTestId={controlBoxDataTestId}
        ref={buttonRef}
        onClick={onClick}
      />
    </div>
  );
};
